<script setup lang="ts">
import EstateListingService from './EstateListingService.vue'
import EstateListingServiceSkeleton from './EstateListingServiceSkeleton.vue'
import { useBox } from '~/composables/api/useBox'
import Container from '~/components/layout/Container.vue'

withDefaults(
  defineProps<{
    showTitle?: boolean
    showBorderTop?: boolean
  }>(),
  {
    showTitle: false,
    showBorderTop: true,
  }
)

const servicesBoxResponse = useLazyAsyncData(
  () => {
    return useBox('estate_listing_services')
  },
  {
    server: false,
  }
)
</script>

<template>
  <div class="c-estate-listing-services">
    <Container class="c-estate-listing-services__container">
      <h2 v-if="showTitle" class="c-estate-listing-services__title h3">
        {{ $t('pages.estateListing.servicesTitle') }}
      </h2>

      <Swiper
        :class="[
          'c-estate-listing-services__swiper',
          showBorderTop && 'has-border-top',
        ]"
        :slides-per-view="'auto'"
        :space-between="40"
        :breakpoints="{
          992: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          1400: {
            slidesPerView: 4,
            spaceBetween: 60,
          },
        }"
      >
        <template v-if="servicesBoxResponse.pending.value">
          <SwiperSlide v-for="i in 4" :key="i">
            <EstateListingServiceSkeleton />
          </SwiperSlide>
        </template>

        <template v-else>
          <SwiperSlide
            v-for="serviceData in servicesBoxResponse.data.value?.box_items"
            :key="serviceData.name"
          >
            <EstateListingService
              :service-data="serviceData"
              class="c-estate-listing-services__item"
            />
          </SwiperSlide>
        </template>
      </Swiper>
    </Container>
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-estate-listing-services {
  &__title {
    max-width: 500px;
    margin: 0 auto 40px;
    line-height: 1;
    text-align: center;
  }

  &__swiper {
    &.has-border-top {
      padding-top: 72px;
      border-top: 1px solid var(--color-border);
    }

    @include breakpoint-down('md') {
      padding: 0 var(--container-padding);
      margin: 0 var(--container-padding-negative);

      &.has-border-top {
        padding-top: 56px;
      }

      :deep(.swiper-slide) {
        width: 200px;
        align-self: stretch;
        height: auto;
      }
    }
  }
}
</style>
